import * as Validator from 'validatorjs'

export default {
  methods: {
    /**
     * Valida o formulário passado com base nas regras,
     * retorna os erros encontrados
     */
    $validator (formData, rules, customMessage) {
      const { $i18n } = this
      Validator.useLang($i18n.locale)

      const validator = new Validator(formData, rules, customMessage || {})
      validator.passes()
      return validator.errors.all()
    }
  }
}
